import { render, staticRenderFns } from "./al-t_2.vue?vue&type=template&id=5c0b3e5f&scoped=true&"
import script from "./al-t_2.js?vue&type=script&lang=js&"
export * from "./al-t_2.js?vue&type=script&lang=js&"
import style0 from "./al-t_2.css?vue&type=style&index=0&id=5c0b3e5f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c0b3e5f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle})
